module.exports = __webpack_public_path__ + "img/icon_map_32_off_001.88925869.png";